import type TokenTransformerFunc from "@ext/markdown/core/edit/logic/Prosemirror/TokenTransformerFunc";

/**
 * A document is made of blocks, and these tags are inline. Standing on their own -- a `<br>` between
 * two paragraphs, an `<u>` on a line by itself -- they arrive with no parent to hold them, and the
 * article fails to build. Each gets a paragraph of its own instead.
 */
const htmlTagTokenTransformer: TokenTransformerFunc = ({ token, transformer, parent }) => {
	if (parent) return;

	if (token.tag === "selfClosingHtmlTag" || token.tag === "inlineHtmlTag")
		return transformer.getParagraphTokens(null, [{ type: token.tag, tag: token.tag, attrs: token.attrs }]);

	if (token.type === "br") return transformer.getParagraphTokens(null, [token]);
};

export default htmlTagTokenTransformer;
